import React from 'react';
import PropTypes from 'prop-types';

import IconOnlyButton from 'components/Buttons/IconOnlyButton';
import logoHeart from 'images/logos/wn-logo-heart-gold.svg';

const MobileSearchOverlay = ({
  oOverlayRef,
  sTitleId,
  fnOnClose,
  bShowBack,
  fnOnBack,
  oChildren,
}) => (
  <div
    ref={oOverlayRef}
    className='advancedSearch__inlineMobile'
    role='dialog'
    aria-modal='true'
    aria-labelledby={sTitleId}
  >
    <div className='advancedSearch__inlineHeaderWrap'>
      <img
        className='advancedSearch__inlineLogo'
        src={logoHeart}
        alt='Heart with a top hat inside'
      />
      <div className='advancedSearch__inlineHeader'>
        <IconOnlyButton
          sIcon='close'
          fnHandleClick={fnOnClose}
          sAriaLabel='Close advanced search'
          className='advancedSearch__inlineClose'
          sFlavor='tertiary'
        />
        <p
          id={sTitleId}
          className='advancedSearch__inlineTitle t-paragraph--medium'
        >
          Advanced Search
        </p>
        {bShowBack ? (
          <IconOnlyButton
            sIcon='arrowTurnLeft'
            fnHandleClick={fnOnBack}
            sAriaLabel='Back'
            className='advancedSearch__inlineBack'
            sFlavor='tertiary'
          />
        ) : (
          // Empty third cell in the 3-column grid so the centered "Advanced
          // Search" title stays centered when no back button is showing.
          <span />
        )}
      </div>
    </div>
    {oChildren}
  </div>
);

MobileSearchOverlay.propTypes = {
  oOverlayRef: PropTypes.shape({ current: PropTypes.any }).isRequired,
  sTitleId: PropTypes.string.isRequired,
  fnOnClose: PropTypes.func.isRequired,
  bShowBack: PropTypes.bool.isRequired,
  fnOnBack: PropTypes.func.isRequired,
  oChildren: PropTypes.node.isRequired,
};

export default MobileSearchOverlay;
